import { create } from 'zustand';

interface HighlightState {
  // Primary highlighted nodes (search results) - shown with thick outline
  highlightedIds: Set<string>;
  // Secondary highlighted nodes (reporting chain) - shown with thinner outline
  reportingChainIds: Set<string>;
  // Highlighted edges (connectors in the chain)
  highlightedEdgeIds: Set<string>;
  // Highlight color
  highlightColor: string;
  // Saved collapsed state to restore when clearing highlights
  savedCollapsedNodeIds: string[] | null;
  // Whether focus mode is active (collapses non-relevant branches)
  focusModeActive: boolean;
  
  setHighlightedIds: (ids: Set<string>) => void;
  setReportingChainIds: (ids: Set<string>) => void;
  setHighlightedEdgeIds: (ids: Set<string>) => void;
  addHighlightedIds: (ids: string[]) => void;
  removeHighlightedIds: (ids: string[]) => void;
  clearHighlights: () => void;
  setHighlightColor: (color: string) => void;
  setSavedCollapsedNodeIds: (ids: string[] | null) => void;
  setFocusModeActive: (active: boolean) => void;
}

export const useHighlightStore = create<HighlightState>((set) => ({
  highlightedIds: new Set(),
  reportingChainIds: new Set(),
  highlightedEdgeIds: new Set(),
  highlightColor: '#2563eb', // Bright blue for visibility
  savedCollapsedNodeIds: null,
  focusModeActive: false,
  
  setHighlightedIds: (ids) => set({ highlightedIds: ids }),
  
  setReportingChainIds: (ids) => set({ reportingChainIds: ids }),
  
  setHighlightedEdgeIds: (ids) => set({ highlightedEdgeIds: ids }),
  
  addHighlightedIds: (ids) => set((state) => ({
    highlightedIds: new Set([...state.highlightedIds, ...ids]),
  })),
  
  removeHighlightedIds: (ids) => set((state) => {
    const newSet = new Set(state.highlightedIds);
    ids.forEach((id) => newSet.delete(id));
    return { highlightedIds: newSet };
  }),
  
  clearHighlights: () => set({ 
    highlightedIds: new Set(),
    reportingChainIds: new Set(),
    highlightedEdgeIds: new Set(),
    focusModeActive: false,
  }),
  
  setHighlightColor: (color) => set({ highlightColor: color }),
  
  setSavedCollapsedNodeIds: (ids) => set({ savedCollapsedNodeIds: ids }),
  
  setFocusModeActive: (active) => set({ focusModeActive: active }),
}));
